import { Howl } from "howler";
import { CoreLogService } from "../log.service";
import { Observable } from "rxjs";

/** UAPP Audio Sounds */
export interface Sound {

  /** Dateipfad in der zu benutzenden Reihenfolge ohne Dateiendung (OGG + MP3 Format mit gleichem Dateinamen und unterschiedlicher Endung) */
  fileURL: string;

  /** Ladevorgang Observable */
  onLoad: Observable<void>;

  /** Abspielen Observable */
  onPlay: Observable<void>;

  /** Abspielende Observable */
  onEnd: Observable<void>;

  /** Pause Observable */
  onPause: Observable<void>;

  /** Stop Observable */
  onStop: Observable<void>;

  /** Stumm schalten Observable */
  onMute: Observable<void>;

  /** Lautstärke ändern Observable */
  onVolume: Observable<void>;

  /** Sounds abspielen */
  play(): void;

  /** Wiedergabe pausieren */
  pause(): void;

  /** Wiedergabe stoppen */
  stop(): void;

  /** Lautstärke anpassen
   * @param volume Lautstärke (0.0 - 1.0)
   */
  volume(volume?: number): void;
}

/** Standardimplementierung */
export class SoundDefault implements Sound {

  private _howl: Howl;

  private _onLoad: Observable<void>;
  private _onPlay: Observable<void>;
  private _onEnd: Observable<void>;
  private _onPause: Observable<void>;
  private _onStop: Observable<void>;
  private _onMute: Observable<void>;
  private _onVolume: Observable<void>;

  /** UAPP Audio Sound Standardimplementierung
 * @param _coreLogService CoreLogService
 * @param _autoplay Automatisch abspielen
 * @param _loop Wiederholen
 * @param _volume Lautstärke
 * @param fileURL  Dateipfad in der zu benutzenden Reihenfolge ohne Dateiendung (OGG + MP3 Format mit gleichem Dateinamen und unterschiedlicher Endung)
 */
  constructor(private _coreLogService: CoreLogService, private _autoplay: boolean, private _loop: boolean, private _volume: number, public fileURL: string) {
    const howlProperties = <IHowlProperties>{
      autoplay: _autoplay,
      loop: _loop,
      volume: _volume,
      src: [fileURL + ".ogg", fileURL + ".mp3"],
      preload: true
    };
    this._howl = new Howl(howlProperties);

    // Observer erstellen
    this.setOnLoad(Observable.create((observer) => {
      this._howl.on("load", () => { observer.onNext(); });
    }));

    this.setOnPlay(Observable.create((observer) => {
      this._howl.on("play", () => { observer.onNext(); });
    }));

    this.setOnEnd(Observable.create((observer) => {
      this._howl.on("end", () => { observer.onNext(); });
    }));

    this.setOnPause(Observable.create((observer) => {
      this._howl.on("pause", () => { observer.onNext(); });
    }));

    this.setOnStop(Observable.create(observer => {
      this._howl.on("stop", () => { observer.onNext(); });
    }));

    this.setOnMute(Observable.create(observer => {
      this._howl.on("mute", () => { observer.onNext(); });
    }));

    this.setOnVolume(Observable.create(observer => {
      this._howl.on("volume", () => { observer.onNext(); });
    }));

  }

  /** Sounds abspielen */
  public play(): void {
    this._howl.play();
  }

  /** Wiedergabe pausieren */
  public pause(): void {
    this._howl.pause();
  }

  /** Wiedergabe stoppen */
  public stop(): void {
    this._howl.stop();
  }

  /** Lautstärke anpassen
   * @param volume Lautstärke (0.0 - 1.0)
   */
  public volume(volume?: number): void {
    this._howl.volume(volume);
  }

  /** Ladevorgang Observable */
  public get onLoad(): Observable<void> {
    return this._onLoad;
  }
  private setOnLoad(value: Observable<void>) {
    this._onLoad = value;
  }

  /** Abspielen Observable */
  public get onPlay(): Observable<void> {
    return this._onPlay;
  }
  private setOnPlay(value: Observable<void>) {
    this._onPlay = value;
  }

  /** Abspielende Observable */
  public get onEnd(): Observable<void> {
    return this._onEnd;
  }
  private setOnEnd(value: Observable<void>) {
    this._onEnd = value;
  }

  /** Pause Observable */
  public get onPause(): Observable<void> {
    return this._onPause;
  }
  private setOnPause(value: Observable<void>) {
    this._onPause = value;
  }

  /** Stop Observable */
  public get onStop(): Observable<void> {
    return this._onStop;
  }
  private setOnStop(value: Observable<void>) {
    this._onStop = value;
  }

  /** Stumm schalten Observable */
  public get onMute(): Observable<void> {
    return this._onMute;
  }
  private setOnMute(value: Observable<void>) {
    this._onMute = value;
  }

  /** Lautstärke ändern Observable */
  public get onVolume(): Observable<void> {
    return this._onVolume;
  }
  private setOnVolume(value: Observable<void>) {
    this._onVolume = value;
  }
}
